
import { throwError as observableThrowError } from 'rxjs';
import { Component, Input } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';

import { ConfigurationService } from '../core/configuration.service';

@Component({
  selector: 'tv-download-file',
  templateUrl: './download.file.component.html'
})
export class DownloadFileComponent {
  @Input() reportName: string;
  // @Input() criteria: any;
  @Input() enableDownload: boolean;

  constructor(private httpClient: HttpClient, private configurationService: ConfigurationService) {
  }

  public generatePDF() {
    const api = this.configurationService.BasePdfReportUrl + this.reportName;
    console.log('Api is', api);
    let params = new HttpParams();
    params = params.append('pageIndex', '0');
    params = params.append('pageSize', '5');
    params = params.append('sortColumn', null);
    params = params.append('sortAscending', 'true');

    this.httpClient.get(api, { params: params, responseType: 'blob' })
      .subscribe(
        (res: any) => {
          console.log('Response for download is ', res);
          const blob = res;
          const filename = this.reportName + '_' + new Date().toLocaleDateString() + '.pdf';
          FileSaver.saveAs(blob, filename);
        },
        (err: HttpErrorResponse) => {
          console.log('Error downloading file', err);
          return observableThrowError(err.error.message || 'Server error');
        });
  }
}
